import { useState } from "react";
import DatePicker1 from "../Components/Feed/DatePicker";
import AttendanceDashboard from "../Components/Reports/Attendance";
import TeamWorkPatterns from "../Components/Reports/Timesheet";
import EmployeeTable from "../Components/Reports/Emergency";
import TeamMemberTable from "../Components/Reports/Teammember";
import WorkforceAnalyticsDashboard from "./Reports";

const ReportPage = () => {
  const [reportType, setReportType] = useState("attendance");

  const getSevenDaysBefore = () => {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    return date.toISOString().slice(0, 10); // "YYYY-MM-DD"
  };

  const getCurrentDay = () => {
    const date = new Date();
    return date.toISOString().slice(0, 10);
  };

  const reportTypes = {
    summary: "Summary",
    attendance: "Attendance & absense",
    timesheet: "Timesheet details",
    emergency: "Emergency contacts",
    teammember: "Team member details",
  };

  const [startTime, setStartTime] = useState(getCurrentDay());
  const [endTime, setEndTime] = useState(getCurrentDay());

  return (
    <div className="w-full flex justify-between">
      <div className="w-[15vw] px-8 pt-12 border-r border-gray-200">
        <div
          onClick={() => setReportType("summary")}
          className={`py-2 px-4 bg-gray-100 text-gray-700 cursor-pointer rounded-md font-semibold mb-2 ${
            reportType == "summary" && "bg-gray-700 text-white"
          }`}
        >
          Summary
        </div>
        <div
          onClick={() => setReportType("attendance")}
          className={`py-2 px-4 bg-gray-100 text-gray-700 cursor-pointer rounded-md font-semibold mb-2 ${
            reportType == "attendance" && "bg-gray-700 text-white"
          }`}
        >
          Attendance & absense
        </div>
        <div
          onClick={() => setReportType("timesheet")}
          className={`py-2 px-4 bg-gray-100 text-gray-700 cursor-pointer rounded-md font-semibold mb-2 ${
            reportType == "timesheet" && "bg-gray-700 text-white"
          }`}
        >
          Timesheet details
        </div>
        <div
          onClick={() => setReportType("emergency")}
          className={`py-2 px-4 bg-gray-100 text-gray-700 cursor-pointer rounded-md font-semibold mb-2 ${
            reportType == "emergency" && "bg-gray-700 text-white"
          }`}
        >
          Emergency contacts
        </div>
        {/* <div
          onClick={() => setReportType("leave")}
          className={`py-2 px-4 bg-gray-100 text-gray-700 cursor-pointer rounded-md font-semibold mb-2 ${
            reportType == "leave" && "bg-gray-700 text-white"
          }`}
        >
          Leave
        </div> */}
        <div
          onClick={() => setReportType("teammember")}
          className={`py-2 px-4 bg-gray-100 text-gray-700 cursor-pointer rounded-md font-semibold mb-2 ${
            reportType == "teammember" && "bg-gray-700 text-white"
          }`}
        >
          Team member details
        </div>
      </div>
      <div className="w-[calc(100%-15vw)] h-screen overflow-y-auto pt-8">
        {reportType !== "summary" &&
          reportType !== "emergency" &&
          reportType !== "teammember" && (
            <div className="flex justify-end items-center px-8">
              <div className="w-full flex items-center gap-4 max-w-xs mb-2">
                <input
                  type="date"
                  id="date"
                  value={startTime}
                  onChange={(e) => setStartTime(e.target.value)}
                  className="block w-32 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-700"
                />
                <input
                  type="date"
                  id="date"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                  className="block w-32 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-700"
                />
              </div>
            </div>
          )}
        {reportType == "summary" && <WorkforceAnalyticsDashboard />}

        {reportType == "attendance" && (
          <AttendanceDashboard startTime={startTime} endTime={endTime} />
        )}
        {reportType == "timesheet" && (
          <TeamWorkPatterns startTime={startTime} endTime={endTime} />
        )}
        {reportType == "emergency" && <EmployeeTable />}
        {reportType == "teammember" && <TeamMemberTable />}
      </div>
    </div>
  );
};

export default ReportPage;
